export default {
  emptyField: 'Campo em branco',
  button: 'Ver mapa astral completo',
  generalError: 'Campo Inválido',
  redirectRoute: 'criar-mapa-astral',
  title: 'Acesse já seu Mapa Astral',
  titleAstrolinkLogo: 'Logo do Astrolink',
  requestError: 'Erro ao realizar o cadastro, por favor verifique seus dados ou tente novamente',
  login: 'Fazer login',
  withFacebook: 'Login com Facebook',
  preferApp: 'Prefere acessar pelo App?',
  termsAndPolicy: `Ao criar uma conta, você concorda com os 
    <a href="/es/terminos-de-uso" class="auth__app-link" rel="noopener noreferrer" target="_blank">Termos de uso</a> 
    e a <a href="/es/privacidad" class="auth__app-link" rel="noopener noreferrer" target="_blank"> Política de privacidade </a> do Astrolink.`,

  haveAccount: {
    text: "Já tem um cadastro?",
    button: "Faça login",
  },

  appInvite: {
    text: "Para se cadastrar via Facebook, Google ou Apple",
    button: "Clique aqui",
  },

  forgotPassword: {
    recovery: "Recuperar senha",
    label: "Esqueci minha senha",
    subTitle: "Informe o seu e-mail para recuperar a sua senha.",
    successMessage: "Enviamos um e-mail com as instruções para recuperação da sua senha",
    errorMessage: "Tivemos problemas ao enviar o email de recuperação",
  },

  modalButtons: {
    cancel: "Cancelar",
    continue: "OK",
  },

  inputDate: {
    invalid: "Data inválida",
    underAge: "Idade inferior a permitida",
    overMaxAge: "Idade acima da permitida",
    placeholder: "Qual sua data de nascimento?",
  },

  inputCity: {
    invalid: "Local inválido",
    placeholder: "Em qual cidade você nasceu?",

    sugestion: {
      strong: "Clique Aqui!",
      span: "Não encontrou sua cidade na lista?",
    },
  },

  birthData: {
    or: 'ou',
    birthTime: "Não sei meu horário de nascimento / Informar depois",
    toolTip:
      "O horário do seu nascimento é o que permite o cálculo do seu ascendente e tudo o que é relativo a ele. É uma informação muito importante para que possamos criar o seu mapa astral completo! Você pode conseguir essa informação em sua certidão de nascimento.",
  },

  personalData: {
    emailSugestion: "Você quis dizer: ",

    placeholders: {
      email: "E-mail",
      gender: "Gênero",
      password: "Senha",
      name: "Nome Completo",
      genderReference: "Como gostaria de ser referenciado?",
    },

    genderOptions: {
      male: "Masculino",
      female: "Feminino",
      notBinary: "Não binário",
    },

    genderReference: {
      he: "Ele",
      she: "Ela",
    },
  },

  errors: {
    tooManyAttempts:
      "Número de tentativas excedido, tente novamente em alguns minutos",
    locked:
      "Não conseguimos validar seu e-mail. Por favor, entre em contato com suporte e forneça o código de erro: #028.",

    dateNotSelected: "Selecione uma data",
    placeNotSelected: "Selecione uma cidade",
    placeNotFound: "Não foi possível encontrar este local",

    invalidName: "^Nome inválido",
    nameEmpty: "^Nome não informado",
    nameFormat: "^Utilize apenas letras",
    nameLength: "^Mínimo de 3 caracteres",

    invalidHour: "Horário inválido",

    genderEmpty: "^Gênero não informado",
    genderReferenceEmpty: "^Referência não informada",

    invalidEmail: "^E-mail inválido",
    invalidEmailFormatted: "E-mail inválido",
    emailEmpty: "^E-mail não foi informado",
    emailExists: "E-mail já cadastrado",
    emailDeleted: "Erro ao validar e-mail #027",
    emailOrPassword: "Email ou senha invalidos",

    passwordEmpty: "^Senha não informada",
    passwordLength: "^Senha muito fraca",
    incorrectPassword: "^Senha incorreta",

    password: {
      invalidPassword: "^Senha inválida",
      tooShort: "Mínimo de 8 caracteres",
      lowComplexity: "Deve conter letras e números",
    },
  },

  timeSelector: {
    hour: "Hora",
    minute: "Minuto",
    period: "Período",
    placeholder: "Qual seu horário de nascimento?",
    title:
      "<span>Selecione a hora e o minuto</span><span>que você nasceu</span>",
  },

  datePicker: {
    year: "Ano",
    month: "Mês",
    cancel: "Cancelar",
    select: "Selecionar",
    title:
      "<span>Selecione o ano, mês e o</span><span>dia em que você nasceu</span>",
    months: {
      January: "Janeiro",
      February: "Fevereiro",
      March: "Março",
      April: "Abril",
      May: "Maio",
      June: "Junho",
      July: "Julho",
      August: "Agosto",
      September: "Setembro",
      October: "Outubro",
      November: "Novembro",
      December: "Dezembro",
    },
  },

  payment: {
    continue: "Continuar",
    button: "Conhecer o premium",
    link: "Voltar para o site",
    birthChartUrl: "/mapa-astral",
    welcome: "Bem vindo de volta, {userName}.<br />O que você quer fazer?",
    paymentUrl: "/assinar",
    nativeUrl: "/",
  },

  maintenance: {
    title: "Ops!",
    message:
      "Parece que os astros estão desalinhados!<br/>Estamos em manutenção no momento.",
    backSoon: "Voltaremos em breve!",
  },

  facebookErrors: {
    deleted: "E-mail inválido",
    default: "Algo inesperado aconteceu, por favor tente novamente",
    googleProvider:
      'Clique no botão "Login com Google" para prosseguir com seu login',
  },

  thirdPartyAuthProviders: {
    signup: {
      apple: 'Cadastre-se com <strong>Apple</strong>',
      google: 'Cadastre-se com <strong>Google</strong>',
      facebook: 'Cadastre-se com <strong>Facebook</strong>',
    }
  },

  themes: {
    LPGuide2021: {
      titleLogin: "Acesse já seu Guia 2021",
      titleBirthData: "Acesse já seu Guia 2021",
      titlePersonalData: "Acesse já seu Guia 2021",
      buttonBirthDataText: "COMEÇAR!",
      buttonPersonalDataText: "Prosseguir",
      buttonPaymentText: "QUERO MEU GUIA!",
    },

    LPBirthChartPayment: {
      buttonPersonalDataText: "Prosseguir",
      buttonPaymentText: "Ver mapa astral completo",
      buttonBirthDataText: "Ver meu mapa astral",
    },

    HomeInterLP: {
      buttonLoginText: "Fazer login",
      buttonBirthDataText: "Continuar",
      buttonPersonalDataText: "Concluir e entrar",
    },

    SignsCombination: {
      buttonPersonalDataText: "Prosseguir",
      buttonPaymentText: "Ver mapa astral completo",
    },

    OrbiaLP: {
      buttonLoginText: "Pergunte ao Orbia",
      buttonPersonalDataText: "Prosseguir",
      buttonBirthDataText: "Pergunte ao Orbia",
    },

    Home: {
      titleLogin: 'Login com E-mail',
      buttonBirthDataText: 'Cadastrar',
      buttonPersonalDataText: 'Continuar',
      titlePersonalData: 'Cadastro por E-mail',
      titleBirthData: 'Faça seu mapa astral gratuito',
      authModalWelcome: "Bem-vindo(a) ao Astrolink",
    },

    FamousMap: {
      titleLogin: "Crie sua conta para visualizar esse perfil!",
      titleBirthData: "Crie sua conta para visualizar esse perfil!",
      titlePersonalData: "Crie sua conta para visualizar esse perfil!",
      buttonLoginText: "Fazer login",
      buttonBirthDataText: "Crie sua conta",
      buttonPersonalDataText: "Prosseguir",
    },

    Horoscope: {
      buttonBirthDataText: 'Ver meu Horóscopo Personalizado',
    }
  },
};
